"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var scenario_node_footer_button_box_styles_1 = require("./scenario-node-footer-button-box.styles");

var GreetingScenarioNodeFooter = function GreetingScenarioNodeFooter(_ref) {
  var accessButtonColor = _ref.accessButtonColor,
      phoneButtonColor = _ref.phoneButtonColor,
      onAccessClick = _ref.onAccessClick,
      onPhoneClick = _ref.onPhoneClick;
  return react_1.default.createElement(scenario_node_footer_button_box_styles_1.ButtonBoxDiv, null, react_1.default.createElement(scenario_node_footer_button_box_styles_1.StyledParagraph, {
    backgroundColor: accessButtonColor,
    onClick: onAccessClick,
    clickable: !!onAccessClick
  }, "\u30A2\u30AF\u30BB\u30B9"), react_1.default.createElement(scenario_node_footer_button_box_styles_1.StyledParagraph, {
    backgroundColor: phoneButtonColor,
    onClick: onPhoneClick,
    clickable: !!onPhoneClick
  }, "\u304A\u96FB\u8A71"));
};

exports.default = GreetingScenarioNodeFooter;